

import Q2DeskAreaCardsPattern, { SelectState } from "./q2_desk_area_cards_pattern";
import EventManager from "../../../../manager/event_manager";

const { ccclass, property, menu } = cc._decorator;

@ccclass
export default class Q2SeatAreaCards extends cc.Component{
    @property([cc.Node])
    nodePosList: cc.Node[] = []

    @property([cc.Node])
    nodePosList1: cc.Node[] = []

    @property(Q2DeskAreaCardsPattern)
    patternPrefab: Q2DeskAreaCardsPattern = null

    @property(cc.Node)
    nodeSelectBg: cc.Node = null
    
    @property(cc.Node)
    nodeSelectPatternParent: cc.Node = null

    @property(cc.Node)
    nodeSelectPatternParent1: cc.Node = null

    protected m_patternList: Q2DeskAreaCardsPattern[] = []
    protected m_usingPatternList: Q2DeskAreaCardsPattern[] = []


    protected m_selectPatternParent: cc.Node = null

    protected resetParent(len: number){
        for (let index = 0; index < this.m_patternList.length; index++) {
            const pattern = this.m_patternList[index];
            if(!pattern){
                continue
            }
            let parent: cc.Node = null
            let selectParent: cc.Node = null
            if(len > this.nodePosList.length){
                parent = this.nodePosList1[index]
                selectParent = this.nodeSelectPatternParent1
            }else{
                parent = this.nodePosList[index]
                selectParent = this.nodeSelectPatternParent
            }   
            pattern.setOriginalParent(parent)
            pattern.setSelectParent(selectParent)
            pattern.node.scale = 1
            pattern.node.position = cc.Vec2.ZERO
        }                
    }

    protected getPattern(index: number, len: number){
        let pattern = this.m_patternList[index]
        if(!pattern){
            pattern = cc.instantiate(this.patternPrefab.node).getComponent(Q2DeskAreaCardsPattern)
            pattern.node.active = true
            let parent: cc.Node = null
            let selectParent: cc.Node = null
            if(index >= this.nodePosList.length || len > this.nodePosList.length){
                parent = this.nodePosList1[index]
                selectParent = this.nodeSelectPatternParent1
            }else{
                parent = this.nodePosList[index]
                selectParent = this.nodeSelectPatternParent
            }   
            pattern.setOriginalParent(parent)
            pattern.setSelectParent(selectParent)
            pattern.node.scale = 1
            pattern.node.position = cc.Vec2.ZERO
            pattern.setClickListener((tmpPattern)=>{    
                let tmpIndex = this.m_patternList.indexOf(tmpPattern)            
                EventManager.instance.dispatch('Q2SeatAreaCards_pattern_click', this, tmpIndex)
            })
            pattern.pattern_selected_state = SelectState.Normal
            this.m_patternList[index] = pattern
        }
        return pattern
    }

    showPokers(show: boolean, codePatternList: number[][]){
        this.m_usingPatternList = []
        if(show){
            for (let index = 0; index < codePatternList.length; index++) {
                const codePattern = codePatternList[index];
                let pattern = this.getPattern(index, codePatternList.length)    
                this.m_usingPatternList.push(pattern)            
                pattern.showPokers(true, codePattern)
            }
            this.resetParent(this.m_usingPatternList.length) 
        }else{            
            for (let index = 0; index < this.m_patternList.length; index++) {
                const element = this.m_patternList[index];
                element.reset()
            }
        }        
    }

    playCardInAnim(index: number, codeList: number[], onFinish: Function, params: {codeList: number[], type: number, fromCompleteProcess: boolean}){        
        const pattern = this.getPattern(index, this.m_patternList.length)  
        if(index >= this.m_usingPatternList.length){
            this.m_usingPatternList.push(pattern)
        }      
        this.resetParent(this.m_usingPatternList.length)      
        pattern.playCardInAnim(codeList, onFinish, params)
    }

    setState(disableIndexList: number[], selectIndexList: number[], normalIndexList: number[]){
        for (let index = 0; index < this.m_usingPatternList.length; index++) {
            let pattern = this.m_usingPatternList[index]
            if(disableIndexList && disableIndexList.indexOf(index) >= 0){
                pattern.pattern_selected_state = SelectState.Disable
            }else if(selectIndexList && selectIndexList.indexOf(index) >= 0){
                pattern.pattern_selected_state = SelectState.Selected
            }else if(normalIndexList && normalIndexList.indexOf(index) >= 0){
                pattern.pattern_selected_state = SelectState.Normal
            }else{
                if(!disableIndexList){
                    pattern.pattern_selected_state = SelectState.Disable
                }else{
                    pattern.pattern_selected_state = SelectState.Normal
                }                
            }
        }
    }

    setPatternState(index: number, state: SelectState){
        let pattern = this.getPattern(index, this.m_patternList.length)
        pattern.pattern_selected_state = state
    }


    refreshPatternSelectState(){
        for (let index = 0; index < this.m_patternList.length; index++) {
            let pattern = this.getPattern(index, this.m_patternList.length)
            pattern.refreshPatternSelectState()
        }
    }

    showSelectBg(show: boolean){
        this.nodeSelectBg.active = !!show
    }
}
